module.exports = __webpack_public_path__ + "static/img/31.9b5b4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/31.png
// module id = MthV
// module chunks = 1